export const KeyboardEventUtil = {
    isStartEditKey: function (e: KeyboardEvent) {
        return e.code === 'F2' || e.code === 'Enter' || e.code === 'NumpadEnter';
    },

    isLineBreakKey: function (e: KeyboardEvent) {
        return (e.altKey || e.ctrlKey || e.metaKey) && (e.code === 'Enter' || e.code === 'NumpadEnter');
    },

    isMoveLeftKey: function (e: KeyboardEvent) {
        return e.code === 'ArrowLeft' || (e.shiftKey && e.code === 'Tab');
    },

    isMoveRightKey: function (e: KeyboardEvent) {
        return e.code === 'ArrowRight' || (!e.shiftKey && e.code === 'Tab');
    },

    isMoveUpKey: function (e: KeyboardEvent) {
        return e.code === 'ArrowUp';
    },

    isMoveDownKey: function (e: KeyboardEvent) {
        return e.code === 'ArrowDown';
    },

    isGripMonitorKey: function (e: KeyboardEvent) {
        return e.code === 'Space';
    },

    isCopyKey(e: KeyboardEvent) {
        return (e.metaKey || e.ctrlKey) && e.code === 'KeyC';
    },
    isPasteKey(e: KeyboardEvent) {
        return (e.metaKey || e.ctrlKey) && e.code === 'KeyV';
    },

    isUndoKey(e: KeyboardEvent) {
        return (e.metaKey || e.ctrlKey) && e.code === 'KeyZ';
    },

    isHelpKey(e: KeyboardEvent) {
        return (e.metaKey || e.ctrlKey) && e.code === 'Slash';
    }
}
